import { createEventBus } from "../../Common/eventBusFactory";

export const eventBus = createEventBus();

export const SELECTED_CATEGORIES_UPDATE = "onSelectedCategoriesUpdate";
